<template>
  <div class="home" ref="home">
    <img class="tapBack" src="@/assets/home/top.png" mode="" />
    <div class="welcome-section">
      <div class="welcome-content">
        <div class="welcome-text">
          <div class="welcome-text__title">H i～，有什么可以帮你</div>
          <div class="welcome-text__desc">你的智能AI小助手</div>
        </div>
        <div class="welcome-image">
          <img src="@/assets/home/AIjl.png" class="welcome-image__pic" />
        </div>
      </div>
    </div>
    <div class="main-container">
      <!-- 第一行：标题+描述 -->
      <div class="header-row">
        <div class="header-title">智能创作</div>
        <div class="header-desc">无限助力灵感和创作</div>
      </div>

      <!-- 第二行：左右分栏 -->
      <div class="content-row">
        <!-- 左侧：上下结构标题+描述 -->
        <div
          class="content-left"
          :style="{ backgroundImage: `url(${bg1})` }"
          @click="toVideo('ai')"
        >
          <div class="left-title">AI主播测评</div>
          <div class="left-desc">音频精准测评</div>
        </div>

        <!-- 右侧：上下两个带背景图的卡片 -->
        <div class="content-right">
          <div
            class="right-card"
            :style="{ backgroundImage: `url(${bg2})` }"
            @click="toVideo('kbVideo')"
          >
            <div class="card-title">口播视频</div>
            <div class="card-desc">播报视频一键生成</div>
          </div>
          <div
            class="right-card"
            :style="{ backgroundImage: `url(${bg3})` }"
            @click="toVideo('pyVideo')"
          >
            <div class="card-title">一键配音</div>
            <div class="card-desc">输入文字转语音</div>
          </div>
        </div>
      </div>
    </div>
    <div class="work-section">
      <!-- 顶部标题栏 -->
      <div class="work-header">
        <div class="work-title">
          工作
        </div>
        <a href="#" class="work-more" @click="goWork">更多&gt;</a>
      </div>

      <!-- v-for循环生成卡片（本地图片） -->
      <div class="work-cards">
        <div
          class="work-card"
          v-for="card in workCardList"
          :key="card.id"
          @click="toVideo('work', card)"
        >
          <img :src="card.icon" class="icon-img" />
          <div class="card-content">
            <div class="card-title">{{ card.title }}</div>
            <div class="card-desc">{{ card.desc }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="work-section">
      <!-- 顶部标题栏 -->
      <div class="work-header">
        <div class="work-title">
          学习
        </div>
      </div>
      <!-- 卡片列表：v-for循环生成一行三卡片 -->
      <div class="card-list">
        <div
          class="card-item"
          v-for="card in cardList"
          :key="card.id"
          @click="toVideo('learn', card)"
        >
          <!-- 卡片图片（本地图片） -->
          <img :src="card.icon" :alt="card.title + '图片'" class="card-img" />
          <!-- 卡片标题 -->
          <div class="card-title">{{ card.title }}</div>
        </div>
      </div>
    </div>
    <div style="height: 1rem"></div>
    <FootTab v-if="isRouterAlive"></FootTab>
  </div>
</template>

<script>
import Vue from "vue";
import FootTab from "@/components/FootTab.vue";
import wx from "weixin-js-sdk";
import { anchorTextListDictInfoWorkType } from "@/api/video";
var gzhstate;
export default {
  name: "home",
  components: {
    FootTab,
  },
  data() {
    return {
      isRouterAlive: true,
      titleshow: true,
      bg1: require("@/assets/home/bg1.png"),
      bg2: require("@/assets/home/bg2.png"),
      bg3: require("@/assets/home/bg3.png"),
      workCardList: [],
      cardList: [],
    };
  },
  created() {
    this.getWorkCardList();
    const userId = this.$route.query.phone;
    if (userId) {
      localStorage.setItem("userId", userId);
    }
    gzhstate = this.AllgetQueryId("state");
    if (gzhstate) {
      this.wxgzh();
      sessionStorage.setItem("gzhstate", gzhstate);
    }
    const ua = navigator.userAgent.toLowerCase();
    if (ua.match(/miniprogram/i)) {
      this.titleshow = true;
    } else {
      this.titleshow = false;
    }
    this.http.getChannelInfo({}).then((res) => {
      if (res.data.status == 1) {
        localStorage.setItem("channelMes", JSON.stringify(res.data.data));
        localStorage.setItem("vipType", res.data.data.vipType);
        document.title = this.titleshow
          ? "央广小主播"
          : res.data.data.channelTitle;
      } else {
        that.$message({
          showClose: true,
          message: res.data.msg,
          type: "error",
        });
      }
    });
  },
  mounted() {},
  methods: {
    async getWorkCardList() {
      const res = await anchorTextListDictInfoWorkType();
      // console.log(res,'---206---');
      if (res.data.code === 200) {
        this.cardList = res.data.data.slice(6, 9);
        this.workCardList = res.data.data.slice(0, 4);
        console.log(this.cardList, "---208---", this.workCardList);
      }
    },
    goWork() {
      event.preventDefault();
      this.$router.push({ name: "work" });
    },
    wxgzh() {
      let than = this;
      let code = than.AllgetQueryId("code"); //去地址栏拿code
      let url = window.location.href;
      if (code == null) {
        this.http.getCode({ redirectUri: url }).then((res) => {
          window.location.href = res.data.data;
        });
      } else {
        this.http.userOpenid({ code: code }).then((res) => {});
      }
    },
    AllgetQueryId(variable) {
      var reg = new RegExp("(^|&)" + variable + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURI(r[2]);
      }
      return null;
    },
    toVideo(videoName, card) {
      console.log(videoName, card, "---220---");
      if (videoName == "learn") {
        this.$router.push({
          path: "/write",
          query: {
            source: "home",
            cardId: card.id,
            cardTitle: card.title,
            href: card.href,
          },
        });
      }else if(videoName == "work"){
        console.log(videoName, card, "---228---");
        this.$router.push({
          path: "/write",
          query: {
            source: "work",
            cardId: card.id,
            cardTitle: card.title,
            href: card.href,
          },
        });
      } else {
        console.log(videoName, card, "---236---");
        this.$router.push({ name: videoName });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.home {
  z-index: 100;
  position: relative;
}

.tapBack {
  width: 100%;
  z-index: -1;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

/* 欢迎区域样式 */
.welcome-section {
  width: 100%;
  height: auto;
  margin-bottom: 30px;
  z-index: 1;

  .welcome-content {
    display: flex;
    width: 90%;
    margin: 0 auto;
    border-radius: 8px;
    justify-content: center;
    align-items: center;
  }

  .welcome-text {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    text-align: left;

    &__title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      margin-bottom: 8px;
      line-height: 1.4;
      margin-top: 18px;
    }

    &__desc {
      font-size: 14px;
      color: #666;
      line-height: 1.5;
      margin-bottom: 8px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .welcome-image {
    flex-shrink: 0;
    width: 120px;
    height: 120px;

    &__pic {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 4px;
    }
  }

  .aiCss {
    width: 46px;
    height: 33px;
    padding: 0 10px;
  }
}

/* 整体容器：宽度90%，居中对齐 */
.main-container {
  width: 90%;
  margin: 0px auto 20px;
  padding: 10px;
  background-color: #fff;
  border-radius: 8px;
}

/* 第一行：标题+描述 */
.header-row {
  display: flex;
  align-items: center;
  margin: 10px 0 20px;
  gap: 15px;
}

.header-title {
  font-size: 22px;
  font-weight: bold;
  color: #333;
}

.header-desc {
  font-size: 14px;
  color: #666;
  font-size: 12px;
  color: #6a8eac;
}

/* 第二行：左右分栏容器 */
.content-row {
  display: flex;
  gap: 20px;
  width: 100%;
}

/* 第二行左侧：上下结构的标题+描述 */
.content-left {
  flex: 1;
  padding: 20px 0px;
  border: 1px solid #eee;
  border-radius: 8px;
  background-size: cover;
  background-position: center;
  text-align: left;
}

.left-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  padding-left: 20px;
}

.left-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  padding-left: 20px;
}

/* 第二行右侧：上下两个带背景图的卡片 */
.content-right {
  flex: 1;
  /* 占据剩余空间（和左侧平分，可调整比例） */
  display: flex;
  flex-direction: column;
  gap: 15px;
  /* 上下两个卡片的间距 */
}

/* 右侧卡片样式：带背景图+上下文字 */
.right-card {
  width: 100%;
  background-size: cover;
  background-position: center;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  color: #fff;
  text-align: left;
}

.card-title {
  font-weight: bold;
  margin-bottom: 8px;
  font-size: 14px;
  color: #072b60;
}

.card-desc {
  font-size: 10px;
  color: #6a8eac;
  line-height: 1.5;
}

/* 整体模块容器 */
.work-section {
  width: 90%;
  /* 可根据需求调整宽度 */
  margin: 20px auto;
}

/* 顶部标题栏：左右对齐 */
.work-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* 左侧“工作”标题 + 彩色小条 */
.work-title {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

/* 右侧“更多>” */
.work-more {
  font-size: 14px;
  color: #999;
  text-decoration: none;
}

.work-more:hover {
  color: #409eff;
}

/* 卡片容器：2列网格布局 */
.work-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  /* 两列平分 */
  gap: 20px;
  /* 卡片之间的间距 */
}

/* 单个卡片样式 */
.work-card {
  display: flex;
  align-items: center;
  padding: 16px;
  background-color: #fff;
  border-radius: 4px;
}

/* 卡片图标（网络图片替代） */
.work-card .icon-img {
  width: 24px;
  height: 24px;
  object-fit: cover;
  margin-right: 12px;
  border-radius: 4px;
}

/* 卡片文字区域 */
.card-content .card-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}

.card-content .card-desc {
  font-size: 12px;
  color: #999;
}

/* 卡片列表：一行三列布局（Grid更简洁） */
.card-list {
  display: flex;
  justify-content: space-between;
}

/* 单个卡片：垂直排列（图片在上，标题在下） */
.card-item {
  width: 31%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 18px 0;
  background-color: #fff;
  border-radius: 8px;
}

/* 卡片图片样式 */
.card-img {
  width: 50px;
  /* 图片宽度铺满卡片 */
  object-fit: cover;
  /* 图片不变形，覆盖容器 */
  border-radius: 6px;
  margin-bottom: 12px;
  /* 图片与标题的间距 */
}

/* 卡片标题样式 */
.card-title {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  /* 标题居中 */
}
</style>
